import React from 'react';
import {
  Avatar,
  Box,
  Typography,
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@mui/material';
import type { Theme } from '@mui/material/styles';

import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

import MediaButton from './MediaButton';
import { Rust, Python } from './Tags';
import CustomEmoji from './CustomEmoji';

function PersonalCard() {
  return (
    <Card
      sx={{
        mb: 3,
        p: 3,
        pb: 2,
        borderRadius: 2,
        border: (t: Theme) => `1px solid ${t.palette.divider}`,
      }}
    >
      <CardHeader
        sx={{p: 0, mb: 2}}
        avatar={<Avatar src={process.env.PUBLIC_URL + '/me.png'} />}
        title="Skylar V. Allen"
        subheader="Research Software Engineer"
      />

      <CardContent
        sx={{ p: 0, '&:last-child': { pb: 0 } }}
      >
        <Typography sx={{ mb: 2 }}>
          Hello! I'm Sky, a research software engineer with ~6 years of experience
          specializing in high-load distributed systems and low-level engineering.
          I mainly code in <Rust /> and <Python />, dealing with scientific
          challenges and making excellent pancakes!
        </Typography>

        <Typography sx={{ mb: 2 }}>
          This is my personal space to share my open-source research, technical
          articles, and projects.
        </Typography>

        <Typography sx={{ mb: 2 }}>
          Welcome <CustomEmoji src="/heart3.png" /> !
        </Typography>

        <Divider>
          <Typography color="text.secondary">Social Media</Typography>
        </Divider>

        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <MediaButton
            text="LinkedIn"
            icon={<LinkedInIcon />}
            href="https://www.linkedin.com/in/alinsky/"
          />
          <MediaButton
            text="GitHub"
            icon={<GitHubIcon />}
            href="https://github.com/SKY-ALIN"
          />
          <MediaButton
            text="Instagram"
            icon={<InstagramIcon />}
            href="https://www.instagram.com/alinsky/"
          />
        </Box>
      </CardContent>
    </Card>
  );
}

export default PersonalCard;
